//https://stackoverflow.com/questions/30915173/react-router-go-back-a-page-how-do-you-configure-history
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./backbutton.css";
import logo from "../icons/newlogo.png";

export default class BackButton extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  onclick() {
    window.location.href = "/";
  }

  render() {
    return (
      <button onClick={this.onclick}>
        <span>
          {<img class="pills-page-logo" src={logo} />}
        </span>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/BackButton.js